// @flow
import * as React from "react";

import { LogoutOutlined } from "@ant-design/icons";

import AuthService from "services/auth";

import getRoleLabel from "utils/getRoleLabel";

import Avatar from "./Avatar";

type Props = {
  children: React.Node,
};

function handleLogout(): void {
  AuthService.logout();

  window.location.replace(`${process.env.REACT_APP_MAIN_SITE_ORIGIN}/login`);
}

function Dropdown({ children }: Props): React.Node {
  const claims = AuthService.getClaims();

  return (
    <li className="nav-item dropdown UserMenu">
      <button
        type="button"
        className="Header-control Header-control--avatar UserMenu-trigger"
        data-bs-toggle="dropdown"
        aria-expanded="false">
        <Avatar alt={claims.name} />
        <span className="UserMenu-trigger__name">{claims.name}</span>
        <span className="UserMenu-trigger__chevron" aria-hidden="true">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M3 4.5L6 7.5L9 4.5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </button>

      <ul className="dropdown-menu dropdown-menu-end UserMenu-dropdown">
        <li className="UserMenu-dropdown__header">
          <div className="UserMenu-dropdown__name">{claims.name}</div>
          <div className="UserMenu-dropdown__subtitle">{getRoleLabel(claims.rol)}</div>
        </li>
        <li>
          <hr className="dropdown-divider UserMenu-dropdown__divider" />
        </li>
        {children}
        <li>
          <button type="button" className="UserMenu-item UserMenu-item--danger" onClick={handleLogout}>
            <span className="UserMenu-item__icon">
              <LogoutOutlined />
            </span>
            <span className="UserMenu-item__label">Sign out</span>
          </button>
        </li>
      </ul>
    </li>
  );
}

export default Dropdown;
